import { render, staticRenderFns } from "./emptyZone.vue?vue&type=template&id=56e54590"
import script from "./emptyZone.vue?vue&type=script&lang=js"
export * from "./emptyZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports